export enum ReturnLineDispositionCode {
    ReturnToDealerDamaged = "ReturnToDealerDamaged",
    ReturnToDealerWrongPart = "ReturnToDealerWrongPart",
    PartNotReceived = "PartNotReceived",
    ReturnToDealerExtLess15 = "ReturnToDealerExtLess15",
    ScrapForDealer = "ScrapForDealer",
    PartialStockPartialRej = "PartialStockPartialRej",
    ReceivedLessThanAuth = "ReceivedLessThanAuth",
    ReturnToStock = "ReturnToStock",
    ReceivedMoreThanAuth = "ReceivedMoreThanAuth",
    MortonDropShip = "MortonDropShip",
    DealerScrapFullCredit = "DealerScrapFullCredit",
    SpecialDealerCredit = "SpecialDealerCredit",
    DealerWillScrap = "DealerWillScrap",
}
